<template>
    <div class="footer">
        <ul class="footMenu">
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/serve">平台服务</router-link></li>
            <li><router-link to="/solution">解决方案</router-link></li>
            <li><router-link to="/contactUs">联系我们</router-link></li>
            <li class="lastOne"><router-link to="/aboutUs">关于迪孚</router-link></li>
        </ul>
        <p class="p1">地址：江苏省南京市&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮箱：market@njdifu.com</p>
        <p class="p2">版权所有：南京迪孚科技有限公司  苏ICP备18007823号</p>
    </div>
</template>
<script>
export default {
  name: 'Foot',
  data () {
    return {
      showChildMenu: false
    }
  },
  methods: {
    enterMenu () {
      this.showChildMenu = true
    },
    leaveMenu () {
      this.showChildMenu = false
    }
  }
}
</script>
<style lang="scss" scoped>
.footer{
    padding:0.5rem 0;
    background:#2c2c2c;
    padding-bottom:0.5rem;
    color:#fff;
    .footMenu{
      margin-bottom:40px;
      >li{
          display: inline-block;
          padding:0 0.1rem;
          line-height:18px;
          font-size:16px;
          color:#fff;
          border-right:1px solid #fff;
      }
        .lastOne{
                border:none;
            }
      }

    .p1{
        font-size:14px;
        color:#fff;
        margin:10px 0;
    }
    .p1 a{
         color:#737573;
         text-decoration:underline;
        cursor: pointer;
    }
    .p2{
        font-size:12px;
    }
    a {
    padding-bottom:4px;
    margin:0 10px;
    color: #fff;
    &.router-link-exact-active {
      color: #fff
    }
  }
  a.router-link-exact-active{
      color:#5352b6;
  }
  @media screen and (max-width:786px){
  .footMenu{
    margin-bottom:0.5rem;
    li{
    font-size:0.16rem;
    padding:0 0.1rem;
  }
  }
  .p1{
    font-size:0.14rem;
  }
  .p2{
    font-size:0.12rem;
  }
}
}

</style>
